const dropMenu = document.querySelector(`[data-menu*="drop"]`);
const iconLines = document.querySelectorAll(`[data-icon*="line"]`);

const dropMenuToggle = () => {
  dropMenu.classList.toggle(`hidden`);
  iconLines.forEach((line) => {
    line.classList.toggle(`open`);
  });
};

//Banner w/Announcement App Position Logic

// Function to update --nav-height variable
const updateNavHeight = (banner, announcementBar) => {
  const bannerHeight = banner.offsetHeight;
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const totalHeight = bannerHeight + announcementBarHeight;
  console.log(totalHeight);  // Debugging statement
  document.documentElement.style.setProperty('--nav-height', `${totalHeight}px`);
};


// Function to handle intersection logic
const handleIntersection = (entries, observer, banner, announcementBar) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      banner.classList.remove('fixed-position');
      updateNavHeight(banner, announcementBar); 
    } else {
      banner.classList.add('fixed-position');
      updateNavHeight(banner, null); 
    }
    
  });
};

// Function to set up the Intersection Observer
const setupObserver = (banner, announcementBar) => {
  const observer = new IntersectionObserver((entries, observer) => handleIntersection(entries, observer, banner, announcementBar));
  observer.observe(announcementBar);
};

// Function to check for the existence of elements and set up observer
const checkAndSetupObserver = () => {
  const banner = document.querySelector('.banner');
  const announcementBar = document.querySelector('#qab_container');
  const navSpace = document.querySelector('.nav-space');

  console.log('Checking for elements:', banner, announcementBar);  // Debugging statement

  if (banner && announcementBar) {
    console.log('Both elements found');  // Debugging statement
    clearInterval(interval);
    banner.classList.remove('fixed-position');
    if (navSpace) {
      navSpace.style.display = 'none';
    }
    updateNavHeight(banner, announcementBar);
    setupObserver(banner, announcementBar);
  }
};

// Set an interval to repeatedly check for the announcement bar
let interval = setInterval(checkAndSetupObserver, 500);
